module.exports = __webpack_public_path__ + "static/media/lhs_circle.95d487a7.svg";